// Auto-generado por @xone-web/staticweb.
// Concatenación de los JS includes del proyecto (orden importa).
// @ts-nocheck — el contenido es JS XOne sin anotaciones de tipo.

// ===== funciones.js =====
// ============================================================
// NinjaCreami - Funciones globales
// ============================================================


// ------------------------------------------------------------
// Polyfill: String.fromCodePoint  (ES6, ECMA-262 21.1.2.2)
// ------------------------------------------------------------
//
// El motor JS de XOne (Rhino) no incluye String.fromCodePoint, por lo que
// no se pueden generar caracteres fuera del BMP (todos los emojis modernos
// estan en el plano 1, U+1F000 en adelante) con la API nativa.
//
// Este polyfill respeta la semantica estandar:
//   - Variadico (acepta N code points).
//   - Valida cada argumento: numero finito, entero, en [0, 0x10FFFF].
//   - Para code points en el BMP (<= 0xFFFF) emite una sola code unit.
//   - Para code points fuera del BMP los descompone en surrogate pair
//     UTF-16 antes de pasarlos a String.fromCharCode.
//   - Va vaciando el buffer en lotes para no exceder el limite practico
//     de argumentos de Function.prototype.apply en motores antiguos.
//
// Una vez registrado el polyfill, cualquier script del proyecto puede
// hacer p. ej. String.fromCodePoint(0x1F4AA) y obtener "??".
//
if (!String.fromCodePoint) {
    String.fromCodePoint = function () {
        var codeUnits = [];
        var result = "";
        var length = arguments.length;
        if (!length) return "";

        for (var index = 0; index < length; index++) {
            var cp = Number(arguments[index]);

            // Validacion: numero, finito, entero, dentro de rango Unicode.
            if (!isFinite(cp) || cp < 0 || cp > 0x10FFFF || Math.floor(cp) !== cp) {
                throw new RangeError("Invalid code point: " + arguments[index]);
            }

            if (cp <= 0xFFFF) {
                // Plano BMP: una sola code unit.
                codeUnits.push(cp);
            } else {
                // Fuera del BMP: descomponer en surrogate pair UTF-16.
                cp -= 0x10000;
                codeUnits.push(
                    (cp >> 10) + 0xD800,    // high surrogate
                    (cp % 0x400) + 0xDC00   // low  surrogate
                );
            }

            // Vaciar buffer al final o si crece demasiado (limite de apply).
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(null, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
}

/**
 * Devuelve true si la cadena es nula, undefined o vacia.
 */
function isEmpty(s) {
    if (s === null || s === undefined) return true;
    var str = "" + s;
    return (str.length === 0 || str === "null" || str === "undefined");
}

/**
 * Convierte un valor a cadena de forma segura.
 */
function cstr(s) {
    if (s === null || s === undefined) return "";
    return "" + s;
}

/**
 * Confirmacion simple basada en msgBox.
 */
function confirmar(mensaje, titulo) {
    try {
        return (ui.msgBox(mensaje, titulo || "Confirmacion", 4) === 6);
    } catch (e) {
        return true;
    }
}

/**
 * Lee una macro global y devuelve "" si no existe.
 */
function getMacroSafe(nombre) {
    try {
        var v = appData.getGlobalMacro(nombre);
        if (v === null || v === undefined) return "";
        return "" + v;
    } catch (e) {
        return "";
    }
}

/**
 * Cierra la pantalla actual.
 */
function cerrarPantalla(obj) {
    try {
        var w = ui.getView(obj);
        if (w) w.exit();
    } catch (e) { }
}

/**
 * Crea un objeto nuevo en la coleccion indicada y abre su pantalla de edicion.
 *
 * Aplica el patron recomendado por XOne para "crear y mostrar":
 *   1. coll.createObject()  -> instancia el DataObject y dispara <create>.
 *   2. coll.addItem(obj)    -> registra el objeto en la coleccion.
 *   3. ui.openEditView(obj) -> abre la pantalla y dispara <before-edit>.
 *
 * Todo el flujo se envuelve en unlock/lock con finally para que la
 * coleccion quede en estado consistente aunque ocurra un error.
 *
 * El callback opcional initFn se invoca despues de addItem y antes de
 * openEditView, permitiendo asignar campos de contexto que no encajan
 * en el evento <create> del XML (por ejemplo IDs heredados del padre,
 * filtros dinamicos, o defaults que dependen de la pantalla origen).
 *
 * @param {string}   nombreColeccion - Nombre de la coleccion (case-sensitive).
 * @param {Function} [initFn]        - (obj) -> void opcional para inicializar
 *                                     campos antes de abrir la pantalla.
 * @returns {Object|null} El DataObject creado, o null si la operacion fallo.
 *
 * @example
 *   // Caso simple: boton "+" en una pantalla de lista
 *   abrirNuevo("Recetas");
 *
 * @example
 *   // Linea hija heredando el ID del registro padre
 *   abrirNuevo("DetalleReceta", function(obj) {
 *       obj["ID_RECETA"] = self["ID"];
 *       obj["ORDEN"]     = self.getCollection("Pasos").getCount() + 1;
 *   });
 */
async function abrirNuevo(nombreColeccion, initFn) {
    if (isEmpty(nombreColeccion)) {
        console.log("[abrirNuevo] nombreColeccion vacio");
        return null;
    }

    var coll = appData.getCollection(nombreColeccion);
    if (!coll) {
        console.log("[abrirNuevo] coleccion no encontrada: " + nombreColeccion);
        return null;
    }

    coll.unlock();
    try {
        var obj = await coll.createObject();
        coll.addItem(obj);

        if (typeof initFn === "function") {
            try {
                initFn(obj);
            } catch (eInit) {
                console.log("[abrirNuevo] error en initFn: " + eInit);
            }
        }

        ui.openEditView(obj);
        return obj;
    } catch (e) {
        console.log("[abrirNuevo] error al crear/abrir: " + e);
        return null;
    } finally {
        coll.lock();
    }
}

// ===== exports para MPA Island mode =====
export { isEmpty, cstr, confirmar, getMacroSafe, cerrarPantalla, abrirNuevo };
